<template>
    <div class="space-y-4 border-t border-gray-200 pt-4">
        <h4 class="text-sm font-semibold text-gray-800">Section Style</h4>

        <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Background Color</label>
            <div class="flex items-center gap-2">
                <input v-model="localSection.styles.backgroundColor" type="color" class="w-12 h-10 border border-gray-300 rounded cursor-pointer" @input="emitUpdate">
                <input v-model="localSection.styles.backgroundColor" type="text" class="flex-1 px-3 py-2 border border-gray-300 rounded-lg" @input="emitUpdate">
            </div>
        </div>

        <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Padding</label>
            <input v-model="localSection.styles.padding" type="text" class="w-full px-3 py-2 border border-gray-300 rounded-lg" placeholder="60px 20px" @input="emitUpdate">
        </div>

        <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">Text Align</label>
            <select v-model="localSection.styles.textAlign" class="w-full px-3 py-2 border border-gray-300 rounded-lg" @change="emitUpdate">
                <option value="left">Left</option>
                <option value="center">Center</option>
                <option value="right">Right</option>
            </select>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        section: { type: Object, required: true },
    },
    emits: ['update'],
    data() {
        return {
            localSection: JSON.parse(JSON.stringify(this.section)),
        }
    },
    watch: {
        section: {
            handler(value) {
                this.localSection = JSON.parse(JSON.stringify(value))
            },
            deep: true,
        },
    },
    methods: {
        emitUpdate() {
            this.$emit('update', JSON.parse(JSON.stringify(this.localSection)))
        },
    },
}
</script>
